import { formatDateString } from "@/v2-common/utils/utils.date"
import cn from "@/v2-ui/utils/utils.cn"
import Badge from "@/v2-backoffice-client/components/badge"
import { DotText } from "@/v2-backoffice-client/components/dot"
import type { InfoGridProps } from "@/v2-backoffice-client/components/infoGrid"
import InfoGrid, {
  createInfoGridFields,
} from "@/v2-backoffice-client/components/infoGrid"
import type { FeatureGroupFragment } from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.fragment"

const FIELDS = createInfoGridFields<FeatureGroupFragment>({
  fields: {
    Code: {
      label: "Code",
      accessor: "Code",
      renderValue({ data }) {
        return (
          <Badge size="sm" variant="neutral">
            {data.Code}
          </Badge>
        )
      },
    },
    // An empty group is the one state worth shouting about: every license and
    // add-on carrying it grants nothing.
    Features: {
      label: "Features",
      accessor: "FeatureCount",
      renderValue({ data }) {
        if (data.FeatureCount === 0) {
          return <DotText variant="destructive">Empty</DotText>
        }
        return data.FeatureCount
      },
    },
    Description: {
      label: "Description",
      accessor: (data) => data.Description ?? null,
      valueClassName: "truncate",
    },
    UpdatedAt: {
      label: "Updated",
      accessor: (data) =>
        data.UpdatedAt ? formatDateString(String(data.UpdatedAt)) : null,
      defaultHidden: true,
    },
    CreatedAt: {
      label: "Created",
      accessor: (data) =>
        data.CreatedAt ? formatDateString(String(data.CreatedAt)) : null,
      defaultHidden: true,
    },
    Id: {
      label: "Id",
      accessor: "Id",
      defaultHidden: true,
    },
  },
})

export type LicenseFeatureGroupViewInfoProps = Omit<
  InfoGridProps<FeatureGroupFragment>,
  "data" | "fields"
> & {
  featureGroup: FeatureGroupFragment | null | undefined
}

function LicenseFeatureGroupViewInfo(props: LicenseFeatureGroupViewInfoProps) {
  const { featureGroup, className, ...infoGridProps } = props

  return (
    <InfoGrid
      id="license-feature-group-info"
      className={cn("license-feature-group-view-info", className)}
      data={featureGroup}
      fields={FIELDS}
      {...infoGridProps}
    />
  )
}

export default LicenseFeatureGroupViewInfo
